<template>
    <b-modal id="demande-code" ref="demande-code" :no-close-on-backdrop="true" hide-footer centered>
        <template #modal-title>
            <h4 style=" margin: 0 auto; color: #4d25bc;"> J-1 WEBINAR - tout savoir sur les rémunérations courtiers
            </h4>
        </template>
        <b-form class="p-2">



            <div class="text-justify">
                <p>
                    J-1 WEBINAR ! Ne manquez pas notre webinar consacré aux rémunérations courtiers demain à 11h00 !
                </p>
            </div>

            <div>
                <b-button variant="primary" size="sm" class="mt-1" @click="suivant">
                    <span class="align-middle text-capitalize">je participe au webinar</span>
                </b-button>
            </div>


        </b-form>







    </b-modal>
</template>

<script>
import {
    BModal,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BButton
} from 'bootstrap-vue'

export default {
    components: {
        BModal,
        BForm,
        BFormCheckbox,
        BFormCheckboxGroup,
        BFormGroup,
        BButton

    },
    data() {
        return {
            currentUser: JSON.parse(localStorage.getItem('userData')),

        }
    },
    mounted() {
        this.showPopup()
    },
    watch: {
        
    },
    methods: {
        showPopup() {
            this.$refs['demande-code'].show()
        },
        suivant() {
            this.$refs['demande-code'].hide()
            window.open('https://app.livestorm.co/bubblein/remunerations-courtiers-panorama-des-remunerations-evolution-des-commissions-et-devoir-de-conseil?s=571bd6fb-525c-4a6f-bba2-048d47afee31&utm_source=pop-up&utm_medium=pop-up&utm_campaign=pop-up', '_blank');
        }
      
    },
  
}
</script>

<style>

</style>
